export interface BatchReminderPostcardRequest {
  returnPlansDateFrom: string
  returnPlansDateTo: string
  dunningDateFrom: string
  dunningDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  radioBranchType: string
  radioUserType: string
  userCodeFrom: string
  userCodeTo: string
  radioUpdate: string
  isUserOutputMultiple: boolean
  isOrderTelInclude: boolean
  isNotLostCollection: boolean
  isNotLostProcedure: boolean
  isRsvCollection: boolean
  isOtherDunningDoc: boolean
  isOutputParents: boolean
  targetAge: string
  isOutputTitle: boolean
  isMailApplicant: boolean
  isOutputDeterrence: boolean
  batchType: string
}

export function BatchReminderPostcardRequestToJSON(
  value: BatchReminderPostcardRequest
): any {
  return {
    return_plans_date_from: value.returnPlansDateFrom,
    return_plans_date_to: value.returnPlansDateTo,
    dunning_date_from: value.dunningDateFrom,
    dunning_date_to: value.dunningDateTo,
    branch_code_from: value.branchCodeFrom,
    branch_code_to: value.branchCodeTo,
    radio_branch_type: value.radioBranchType,
    radio_user_type: value.radioUserType,
    user_code_from: value.userCodeFrom,
    user_code_to: value.userCodeTo,
    radio_update: value.radioUpdate,
    is_user_output_multiple: value.isUserOutputMultiple,
    is_order_tel_include: value.isOrderTelInclude,
    is_not_lost_collection: value.isNotLostCollection,
    is_not_lost_procedure: value.isNotLostProcedure,
    is_rsv_collection: value.isRsvCollection,
    is_other_dunning_doc: value.isOtherDunningDoc,
    is_output_parents: value.isOutputParents,
    target_age: value.targetAge,
    is_output_title: value.isOutputTitle,
    is_mail_applicant: value.isMailApplicant,
    is_output_deterrence: value.isOutputDeterrence,
    batch_type: value.batchType
  }
}
